import { createContext, useContext, type ReactNode } from 'react';
import { assert } from '~/lib/assert';
import type { SignalFilters, SignalFiltersState } from './';

export type SignalFiltersContextType = SignalFiltersState & {
  clearFilters: () => void;
  reinitialize: (params: string) => void;
  setFilter: (
    field: {
      [K in keyof SignalFilters]: { field: K; items: SignalFilters[K]['items']; open?: boolean };
    }[keyof SignalFilters],
  ) => void;
  toggleFilter: (field: keyof SignalFilters) => void;
  togglePanel: () => void;
};

export const SignalFiltersContext = createContext<SignalFiltersContextType | undefined>(undefined);

export const useSignalFilters = () => {
  const context = useContext(SignalFiltersContext);
  assert(context !== undefined, 'useSignalFilters must be used with a SignalFiltersProvider');
  return context;
};

export interface SignalFiltersProviderProps extends SignalFiltersContextType {
  children: ReactNode;
}

export const SignalFiltersProvider = ({ children, ...rest }: SignalFiltersProviderProps) => (
  <SignalFiltersContext.Provider value={{ ...rest }}>{children}</SignalFiltersContext.Provider>
);
